import { debounce } from 'lodash'

export default {
  inserted(el, binding) {
    const callback = binding.value
    const options = binding.options || { passive: true }

    el.__resizeHandler__ = {
      callback,
      options
    }

    window.addEventListener('resize', debounce(callback, 250), options)

    if (!binding.modifiers || !binding.modifiers.quiet) {
      callback()
    }
  },

  unbind(el, binding) {
    if (!el.__resizeHandler__) {
      return
    }

    const { callback, options } = el.__resizeHandler__

    window.removeEventListener('resize', debounce(callback, 250), options)
    delete el.__resizeHandler__
  }
}
